import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';

import { AddBridgePoolDialogBody, AddBridgePoolDialogProps, AddBridgePoolDialogState } from '~src/app/content/AddBridgePoolDialog';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { cssClass } from '~src/style';
import { EdgePool } from '~src/ts/resources/EdgePool';
import { ICreateEdgePoolResult } from '~src/ts/ServerApi/requests/CreateEdgePoolRequest';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';

const addPoolButtonClass = cssClass('add-pool', 'root', {
  display: 'block',
  marginBottom: TabStyles.Spacing.DefaultSpace
});

const addPoolIconClass = cssClass('add-pool', 'icon', {
  verticalAlign: 'middle'
});

export type AddNewPoolButtonProps = Readonly<{
  existingPoolNames: ReadonlyArray<string>;
  siteId: string;
  refreshEdgePools: () => void;
}>;

export function AddNewPoolButton(props: AddNewPoolButtonProps) {
  return (
    <ButtonWidget
      title={Messages.bridgeSiteSettingsAddPool()}
      buttonType={ButtonType.Outline}
      testId={'add-new-pool-button'}
      onClick={() => openAddNewPoolDialog(props.existingPoolNames, props.siteId, props.refreshEdgePools)}
      className={addPoolButtonClass}
    >
      <img src={imgPath('plus_14px-small.svg')} alt={''} className={addPoolIconClass} />
      <span> {Messages.bridgeSiteSettingsAddPool()} </span>
    </ButtonWidget>
  );
}

function openAddNewPoolDialog(existingPoolNames: ReadonlyArray<string>, siteId: string, refreshEdgePools: () => void) {
  const action = (_: AddBridgePoolDialogProps, state: AddBridgePoolDialogState) => {
    EdgePool.createPool({ displayName: state.poolName, siteId: siteId, bridgeSettingsVersion: '0' })
      .then((result: ICreateEdgePoolResult) => {
        refreshEdgePools();
        if (result.error) {
          // TODO - ndepass 9/14/21 - Story 1297102: [BridgeSiteSettings] Create Multi-Pool table
          ToasterService.instance.pop({ type: ToastType.Error, text: Messages.errorUnknown() });
        }
        if (result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.bridgeSiteSettingsAddPoolSuccess() });
        }
      });
    return Promise.resolve();
  };

  const dialogInstance = openReactActionDialog({
    title: Messages.bridgeSiteSettingsAddPool(),
    bodyComponent: AddBridgePoolDialogBody,
    initialBodyProps: { existingPoolNames },
    initialDialogState: { poolName: '', hasError: false },
    actionName: Messages.save(),
    action: action,
    actionDisabled: (_, state: AddBridgePoolDialogState) => state.poolName.length === 0 || state.hasError,
    dismissDialogOnActionFailed: false,
    dialogWidth: TabDialogWidth.width375px,
  });

  return Promise.resolve(dialogInstance.result);
}
